<template>
  <div class="py-5" style="max-width: 700px; margin: auto;">
    <loading-spinner v-if="loading" />
    <b-card v-else>
      <connected-view
        v-if="item"
        :url="item.url"
        @delete="handleDelete"
        @edit="handleEdit"/>

      <not-connected-view
        v-else
        @create="handleEdit"/>

      <confirm-delete
        v-if="deleteSessionID"
        :key="deleteSessionID"
        @close="handleDeleteClose"/>

      <editor
        v-if="editSessionID"
        :key="editSessionID"
        @close="handleEditClose"/>
    </b-card>
  </div>
</template>

<script>
  import ConnectedView from './Connected';
  import NotConnectedView from './NotConnected';
  import ConfirmDelete from './ConfirmDelete';
  import Editor from './Editor';
  import LoadingSpinner from '../LoadingSpinner';
  import axios from 'axios';
  import {fullURL} from '../../utils';

  const uniqueID = () => (new Date()).getMilliseconds();

  export default {
    name: 'ExternalAnalyticsManager',

    components: {
      ConnectedView,
      NotConnectedView,
      ConfirmDelete,
      Editor,
      LoadingSpinner
    },

    data() {
      return {
        editSessionID: null,
        deleteSessionID: null,
        item: null,
        loading: true
      };
    },

    created() {
      axios.get(fullURL(`/external-analytics`))
        .then(({data}) => {
          this.item = data;
        })
        .catch(console.log)
        .finally(() => {
          this.loading = false;
        });
    },

    methods: {
      handleDelete() {
        this.deleteSessionID = uniqueID();
      },

      handleDeleteClose(deleted = false) {
        this.deleteSessionID = null;
        if (deleted) {
          this.item = null;
        }
      },

      handleEdit() {
        this.editSessionID = uniqueID();
      },

      handleEditClose(item = null) {
        this.editSessionID = null;
        if (item) {
          this.item = item;
        }
      }

    }
  };
</script>

<style scoped>

</style>
